module.exports = __webpack_public_path__ + "img/underground_comm_fault_on.4f00189c.svg";